import React from "react";
import {
    Cell,

    Legend,

    Pie,
    PieChart,
 Tooltip,

} from "recharts";
import {Grid} from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import mock from "../mock.json";



const TipoCorrecaoPieChart = (props) => {

    const  data  = props.data? props.data : mock.periodo.totaisCorrecoes;

    const width = props.width? props.width : 250;
    const height = props.height? props.height : 250;
    const titulo = props.titulo? props.titulo : 'CORREÇÕES';

    const gwidth = width-20;
    const gheight = height - 20;


    const RADIAN = Math.PI / 180;

    const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042'];

    const renderCustomizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent, index }) => {
        const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
        const x = cx + radius * Math.cos(-midAngle * RADIAN);
        const y = cy + radius * Math.sin(-midAngle * RADIAN);

        return (
            <text x={x} y={y} fill="white" textAnchor={x > cx ? 'start' : 'end'} dominantBaseline="central">
                {`${(percent * 100).toFixed(0)}%`}
            </text>
        );
    };


    return(
        <Grid container item style={{backgroundColor: "white", width: width, height: height }}>
            <Grid container item justifyContent={"center"}>
                <Typography>{titulo}</Typography>
            </Grid>
            <Grid item style={ {width: gwidth, height: gheight, margin: 0, padding: 0}}>


                <PieChart width={gwidth} height={gheight}>
                    <Pie
                        dataKey="quantidade"
                        isAnimationActive={false}
                        data={data}
                        cx="50%"
                        cy="50%"
                        innerRadius={30}
                        outerRadius={45}
                        nameKey="tipoCorrecao"


                        label
                    >
                        {data.map((entry, index) => (
                            <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                        ))}
                    </Pie>
                    <Legend/>


                </PieChart>

            </Grid>
        </Grid>
    );

}

export default TipoCorrecaoPieChart;